export default __webpack_public_path__ + "static/media/card-theme8.9675f38a.svg";